import React, { useState } from "react";
import PropTypes from "prop-types";
import "./orderLoss.css";
import InfoIcon from "../../../../../../assets/images/InfoIcon.svg";

const UNIT_MAP = {
  Tonnes: "T",
  tonnes: "T",
  Eaches: "E",
  eaches: "E",
  Cases: "Cs",
  cases: "Cs",
  Value: "Rs",
  value: "Rs",
  Rs: "Rs",
};

const fullValueText = (val) =>
  typeof val === "number" ? val.toLocaleString("en-IN") : String(val ?? "");

const formatDigitsWithEllipsis = (val) => {
  if (val == null) return "";
  const str = String(val);
  const digitCount = (str.match(/\d/g) || []).length;
  if (digitCount > 7) {
    const compact = str.replaceAll(/\D/g, "");
    const head = compact.slice(0, 7);
    const sign = str.trim().startsWith("-") ? "-" : "";
    return `${sign}${head}…`;
  }
  return str;
};

function InfoWithHover({ label = "Info", description }) {
  const [show, setShow] = useState(false);

  if (!description) {
    return (
      <span className="info-wrapper" aria-hidden="true">
        <img src={InfoIcon} alt="Info" height="12" width="12" />
      </span>
    );
  }

  return (
    <button
      type="button"
      className="info-wrapper"
      aria-label={label}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onFocus={() => setShow(true)}
      onBlur={() => setShow(false)}
      >
      <img src={InfoIcon} alt="Info" height="12" width="12" />
      {show && (
        <span className="ol-tooltip" role="tooltip">
          <span className="ol-tooltip-caret" />
          {description}
        </span>
      )}
    </button>
  );
}

InfoWithHover.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

function Tile({ tileData }) {
  const totalRow = tileData?.Total;
  const childSection = tileData?.OrderLossBuckets;

  return (
    <>
    <div className="orderlossTile">
      <div className="orderlossTileHeader">
        <div className="summarySection">
          <div className="summaryLabel">
            <span>{totalRow?.name}</span>
            <InfoWithHover description={totalRow?.description} />
          </div>

          <div className="summaryMetric">
            <span
              className="summaryMetricValue valueEllipsisOl"
              title={fullValueText(totalRow?.value)}
              data-fullvalue={fullValueText(totalRow?.value)}
            >
              {totalRow?.value}
            </span>
            &nbsp;
            <span className="metricUnit">{UNIT_MAP[totalRow?.unit]}</span>
          </div>
        </div>
        <div className="lineSeparator"></div>
        <div className="bucketsSection">
          <div className="bucketHeader">{childSection?.containerName}</div>

          <div className="bucketList">
            {childSection?.lossContents?.map((c) => (
              <div key={c.name} className="bucketItem">
                <div className="bucketItemHeader">
                  <span className="bucketItemName">{c.name}</span>
                  <InfoWithHover description={c?.description} />
                </div>

                <div className="bucketItemMetric">
                  <span className="bucketItemValue">
                    <span
                      className="bucketItemValueMain valueEllipsisOl"
                      title={fullValueText(c.value)}
                      data-fullvalue={fullValueText(c.value)}
                    >
                      {formatDigitsWithEllipsis(c.value)}
                    </span>
                    &nbsp;
                    <span className="metricUnit">{UNIT_MAP[c.unit]}</span>
                  </span>
                  <span className="kpiPercent">{c.percentage}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    <div className="lineSeparator"></div>
     </>
  );
}

Tile.propTypes = {
  tileData: PropTypes.shape({
    Total: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      unit: PropTypes.string,
    }),
    OrderLossBuckets: PropTypes.shape({
      containerName: PropTypes.string,
      lossContents: PropTypes.arrayOf(PropTypes.object),
    }),
  }),
};

const OrderLoss = ({ data }) => {
  return <Tile tileData={data} />;
};

export default OrderLoss;

OrderLoss.propTypes = {
  data: PropTypes.shape({
    Total: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      unit: PropTypes.string,
    }),
    OrderLossBuckets: PropTypes.shape({
      containerName: PropTypes.string,
      lossContents: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          description: PropTypes.string,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          unit: PropTypes.string,
          percentage: PropTypes.number,
        })
      ),
    }),
  }),
};